module.exports = global["videojs"] = require("-!.\\video.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?videojs!./node_modules/video.js/es5/video.js
// module id = 71
// module chunks = 0